import Input from '../../common/Input';
import TextArea from '../../common/TextArea';
import CheckBox from "../../common/CheckBox";
import Select from "../../common/Select";

export const details = {

  id: 0,

  name: 'details',
  _system: {
    name: 'Details',
    relatedTo: 'details',
  },

  detail_id: {
    system: {
      name: 'id',
      relatedTo: 'details',
    },
    name: 'id',
    value: '',
    rules: {
    },
  },

  caption: {
    label: 'Caption',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'caption',
      relatedTo: 'details',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'caption',
    rules: {
      title: 'Caption field',
      required: true,
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Fill-in this field.',
    system: {
      component: Input,
      name: 'content',
      relatedTo: 'details',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'description',
    rules: {
      title: 'Description field',
      required: true,
    }
  },
};


export const sales_persons = {
  id: 0,
  name: 'sales_persons',
  _system: {
    name: 'Sales Rep',
    relatedTo: 'sales_persons',
  },
  system: {
    name: 'sales_persons',
  },
  sales_persons_id: {
    system: {
      name: 'id',
      relatedTo: 'sales_persons',
    },
    name: 'id',
    value: '',
    rules: {
    },
  },
  relation_id: {
    name: 'relation_id',
    system: {
      name: 'relation_id',
      relatedTo: 'relation_id',
    },
    value: '',
    rules: {
    },
  },
  user_id: {
    name: 'user_id',
    system: {
      name: 'user_id',
      component: Select,
      relatedTo: 'sales_persons',
    },
    value: '',
    errors: [],
    type: 'text',
    rules: {
    },
  },
  username: {
    name: 'username',
    system: {
      name: 'username',
      relatedTo: 'sales_persons',
    },
    value: '',
  },
};


export const contacts = {

    id: 0,

    name: 'contacts',
    _system: {
      name: 'Contacts',
      relatedTo: 'contacts',
    },

    user_id: {
      system: {
        name: 'user_id',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      rules: {
      },
    },
    types: {
      label: 'Set types',
      placeholder: '',
      system: {
        name: 'type',
        relatedTo: 'contacts',
      },
      value: [],
      errors: [],
      type: 'hidden',
      name: 'types',
      rules: {
      }
    },
    billing: {
      label: 'Set as "Billing"',
      placeholder: '',
      system: {
        component: CheckBox,
        name: 'billing',
      },
      value: false,
      errors: [],
      type: 'text',
      name: 'billing',
      rules: {
      }
    },
    shipping: {
      label: 'Set as "Shipping"',
      placeholder: '',
      system: {
        component: CheckBox,
        name: 'shipping',
      },
      value: false,
      errors: [],
      type: 'text',
      name: 'shipping',
      rules: {
      }
    },
    firstname: {
      label: 'First Name',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'firstname',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'firstname',
      rules: {
        title: 'Firs name field',
        required: true,
      }
    },
    lastname: {
      label: 'Last Name',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'lastname',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'lastname',
      rules: {
        title: 'Last name field',
        required: true,
      }
    },
    email: {
      label: 'Email',
      placeholder: 'Fill-in this field.',
      value: '',
      system: {
        component: Input,
        name: 'email',
        relatedTo: 'contacts',
      },
      errors: [],
      type: 'email',
      name: 'email',
      rules: {
        title: 'Email field',
        required: true,
        email: true,
      }
    },
    company: {
      label: 'Company',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'company',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'company',
      rules: {
        title: 'Company field',
        // required: true,
      }
    },
    companyAddress: {
      label: 'Company Address',
      placeholder: 'Fill-in this field.',
      system: {
        component: TextArea,
        name: 'address',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'companyAddress',
      rules: {
        title: 'Company Address field',
      }
    },
    phone: {
      label: 'Phone',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'phone',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'phone',
      rules: {
        title: 'Phone field',
      }
    },
    fax: {
      label: 'Cell',
      placeholder: 'Fill-in this field.',
      system: {
        component: Input,
        name: 'fax',
        relatedTo: 'contacts',
      },
      value: '',
      errors: [],
      type: 'text',
      name: 'fax',
      rules: {
        title: 'Cell field',
        // numeric: true,
      }
    },
};

export const basic = {
  username: {
    label: 'Name',
    placeholder: 'Fill-in this field.',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'User name field',
      required: true,
    }
  },
  terms: {
    label: 'Terms',
    value: '',
    errors: [],
    name: 'terms',
    system: {
      name: 'term',
    },
    rules: {
      title: 'Terms field',
      required: true,
    },
    options: ['COD', 'Net 30', 'Net 45', 'Net 60', 'Net 75', 'Net 90']
  },
  taxing: {
    label: 'Taxing',
    value: '',
    errors: [],
    name: 'taxing',
    system: {
      name: 'taxing',
    },
    rules: {
      title: 'Taxing field',
      required: true,
    },
    options: ["Taxable", "Non-taxable"]
  },
  sales_persons: [],
  details: [],
  contacts: [],
  remove_project_detail_ids: [],
};



// WEBPACK FOOTER //
// ./src/containers/EditCustomer/fields.js